import { useAtomValue } from 'jotai';
import { tradingClassificationAtom } from '../../state';

export const useTradingClassificationCommon = () => {
  const tradingClassification = useAtomValue(tradingClassificationAtom);

  return {
    tradingClassification,
  };
};
